// extracted by mini-css-extract-plugin
export default {"iframeContainer":"frontpage_iframeContainer__7mCXm","NewsContainer":"frontpage_NewsContainer__Y8MHZ"};